// extracted by mini-css-extract-plugin
module.exports = {"root":"_2gjXA","bg":"_3-8Iz","ctr":"bh0pp","top":"_3pbXM","bot":"_3UMLe"};